import React, { useEffect, useState } from "react";
import Footer from "../../components/Footer";
import NavBar from "../../components/NavBar";
import SideBar from "../../components/SideBar";
import { paramSinistreMockData } from "../../utils/navbarUtils";

const sinistreParameters = [
  {
    title: "Paramétrage du numéro de sinistre",
    description: "Paramétrer le numéro de sinistre",
    link: "/autre-parametres/numero-sinistre",
    button: "Définir le numéro de sinistre",
  },
  {
    title: "Paramétrage des causes de sinistre",
    description: "Paramétrer les différentes causes de sinistre",
    link: "/autre-parametres/cause-sinistres",
    button: "Définir une nouvelle cause",
  },
  {
    title: "Paramétrage des préjudices",
    description: "Paramétrer les différents préjudices",
    link: "/autre-parametres/prejudices",
    button: "Définir un nouveau préjudice",
  },
  {
    title: "Paramétrage des natures d'actes",
    description: "Paramétrer les différentes natures d'actes",
    link: "/autre-parametres/nature-acte",
    button: "Définir une nouvelle nature d'acte",
  },
  {
    title: "Paramétrage des experts",
    description: "Gérer les experts disponibles pour les dossiers sinistres",
    link: "/autre-parametres/experts",
    button: "Gérer les experts",
  },
  {
    title: "Paramétrage des entités de constat",
    description: "Paramétrer les différentes entités de constat",
    link: "/autre-parametres/entites-constat",
    button: "Définir une nouvelle entité",
  },
  {
    title: "Paramétrage de la somme minimale des sinistres à payer",
    description: "Paramétrer les différentes sommes",
    link: "/autre-parametres/somme-minimale-a-payer",
    button: "Définir une nouvelle somme",
  },
  {
    title: "Paramétrage du barème d'évaluation",
    description:
      "Paramétrer le barème d'évaluation à l'ouverture d'un dossier sinistre",
    link: "/autre-parametres/bareme-evaluation",
    button: "Définir le barème",
  },
  {
    title: "Paramétrage des types de pièces",
    description: "Paramétrer les différents types de pièces",
    link: "/autre-parametres/type-pieces",
    button: "Définir un type de pièce",
  },
  {
    title: "Paramétrage du SMIG",
    description: "Paramétrer le SMIG",
    link: "/parametres/smig",
    button: "Définir le SMIG",
  },
  {
    title: "Paramétrage de la valeur point IP",
    description: "Paramétrer la valeur point IP",
    link: "/parametres/ajouter-valeur-point-ip",
    button: "Définir la valeur point IP",
  },
  {
    title: "Paramétrage de l'âge limite de paiement de rente",
    description: "Paramétrer l'âge limite de paiement de rente",
    link: "/parametres/age-limite-paiement-rente",
    button: "Définir l'âge limite de paiement de rente",
  },
  {
    title: "Paramétrage des Pretium Doloris",
    description: "Paramétrer les Pretium Doloris",
    link: "/parametres/pretium-doloris",
    button: "Définir les Pretium Doloris",
  },
  {
    title: "Paramétrage des établissements",
    description: "Paramétrer les différents établissements",
    link: "/autre-parametres/etablisements",
    button: "Définir un nouvel établissement",
  },
  {
    title: "Paramétrage des types d'établissement",
    description: "Gérer les types d'établissement utilisés dans les sinistres",
    link: "/autre-parametres/type-etablissements",
    button: "Ajouter un type d'établissement",
  },
];



const ParametresSinistres = () => {
  const [searchResults, setSearchResults] = useState([]);
  const [searchValue, setSearchValue] = useState("");

  const renderSearchResults = (results) => {
    return (
      results.map(({ category, items }) => (
        <div key={category} className="px-3 py-2">
          <h6 className="text-muted text-uppercase mb-2">
            {category}
          </h6>
          {items
            .filter((item) =>
              item.name.toLowerCase().includes(searchValue.toLowerCase())
            )
            .map((item, index) => (
              <a
                key={index}
                href={item.url}
                className="dropdown-item d-flex align-items-center gap-2 py-1"
              >
                <i className={`bx ${item.icon} text-muted`}></i>
                <span className="text-truncate">{item.name}</span>
              </a>
            ))}
        </div>
      ))
    );
  }

  useEffect(() => {
    if (searchValue && searchValue?.length > 2) {
      let results = [];
      Object.keys(paramSinistreMockData).forEach((key) => {
        const filtered = paramSinistreMockData[key].filter((item) =>
          item.name.toLowerCase().includes(searchValue.toLowerCase())
        );
        if (filtered.length) {
          results.push({ category: key, items: filtered });
        }
      });
      setSearchResults(results);
    }
  }, [searchValue]);
  return (
    <div className="layout-wrapper layout-content-navbar">
      <div className="layout-container">
        <SideBar currentMenu={"PARAMETRES_SINISTRES"} />
        <div className="layout-page">
          <NavBar
            filteredResults={searchResults}
            setFilteredResults={setSearchResults}
            renderSearchResults={renderSearchResults}
            searchValue={searchValue}
            setSearchValue={setSearchValue}
          />
          <div className="content-wrapper">
            <div className="container-xxl flex-grow-1 container-p-y">
              <div className="row g-4">
                {sinistreParameters.map(({ title, description, link, button }) => (
                  <div key={title} className="col-md-6 col-lg-4">
                    <div className="card h-100 shadow-sm border-0">
                      <div className="card-body d-flex flex-column">
                        <h5 className="card-title fw-bold mb-2">{title}</h5>
                        <p className="card-text flex-grow-1 text-muted">{description}</p>
                        <a href={link} className="btn btn-primary mt-2">
                          {button}
                        </a>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <Footer />
            <div className="content-backdrop fade"></div>
          </div>
        </div>
      </div>
      <div className="layout-overlay layout-menu-toggle"></div>
      <div className="drag-target"></div>
    </div>
  );
};

export default ParametresSinistres;
